<div class="headerrow row align-center">
    <div class="left-wrapper">
        <img
            class="small-cloud"
            src="/images/dashboard/cloud_small.svg"
            alt="small clouds"
        />
        <img class="rocket" src="/images/dashboard/rocket.svg" alt="rocket" />
    </div>
    <div class="row w100 space-between align-center">
        <div class="col gap-8">
            <h1 i18n>
                Welcome<span *ngIf="userData?.prename"
                    >, {{ userData?.prename }}</span
                >
            </h1>
            <h4 i18n>A great day to disrupt the world with your innovation!</h4>
        </div>

        <div class="rightactionbar row gap-16">
            <rr-btn
                iconStart="add"
                type="SecondaryWhite"
                i18n
                (click)="newStream()"
                >New Stream</rr-btn
            >
        </div>
    </div>

    <!-- <div class="right-wrapper">
        <img class="clouds" src="/images/dashboard/cloud.svg" alt="clouds" />
    </div> -->
</div>
